import { render, staticRenderFns } from "./freight_edit.vue?vue&type=template&id=88d4e486&scoped=true"
import script from "./freight_edit.vue?vue&type=script&lang=ts"
export * from "./freight_edit.vue?vue&type=script&lang=ts"
import style0 from "./freight_edit.vue?vue&type=style&index=0&id=88d4e486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d4e486",
  null
  
)

export default component.exports